interface FormSectionProps {
  sectionTitle?: string
  children: React.ReactNode
}

/** Sekce formuláře: nadpis a obsah bez rámečku, oddělení dělá odsazení. */
export const FormSection = ({ children, sectionTitle }: FormSectionProps) => {
  return (
    <section className="grid content-start gap-4">
      {sectionTitle && <h3 className="text-sm font-medium">{sectionTitle}</h3>}

      {children}
    </section>
  )
}
